import React from 'react';
import Button from '../../../components/base/Button';

const TreatmentHero: React.FC = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(16, 185, 129, 0.8), rgba(6, 182, 212, 0.6)), url('https://public.readdy.ai/ai/img_res/3f7bcf0db98760f84d292f733c4360b5.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="w-full text-center text-white">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Advanced <br />
            <span className="text-yellow-300">Treatment Solutions</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto leading-relaxed">
            Discover our comprehensive range of <strong>cutting-edge therapies</strong> designed to optimize your health, 
            enhance vitality, and support your wellness journey through <strong>personalized medicine</strong> approaches.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button variant="secondary" size="lg" className="min-w-48">
              <i className="ri-microscope-line mr-2"></i>
              Explore All Treatments
            </Button>
            <Button variant="outline" size="lg" className="min-w-48 border-white text-white hover:bg-white hover:text-teal-600">
              <i className="ri-calendar-line mr-2"></i>
              Schedule Consultation
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TreatmentHero;